module.exports = __webpack_public_path__ + "img/mag-hiw.5d00dd41.png";